module.exports = __webpack_public_path__ + "img/ring_r_c_null_null@3x.b88715f4.png";